export default "__VITE_ASSET__BiNsA$ei__"